module.exports = __webpack_public_path__ + "img/76.6a8c0f87.jpg";